import React from 'react';
import PropTypes from 'prop-types';
import { combineClassNames, useTheme } from '../css';
import { SvgIcon } from '../icons';

export const BUTTON_KEY = 'button';
export const TEXT_KEY = 'text';

const ButtonText = ({ className, ...restProps }) => (
  <div
    className={combineClassNames('button__text', className)}
    {...restProps}
  />
);

const ButtonIcon = ({ className, ...restProps }) => (
  <SvgIcon
    className={combineClassNames('button__icon', className)}
    {...restProps}
  />
);

const getAnalyticsClass = analytics => {
  if (analytics === BUTTON_KEY) {
    return 'stat-button-link';
  }
  if (analytics === TEXT_KEY) {
    return 'stat-text-link';
  }
  return '';
};

const Button = ({
  as: Type = 'button',
  primary,
  secondary,
  className,
  analytics,
  ...restProps
}) => (
  <Type
    type={Type === 'button' ? 'button' : null}
    className={combineClassNames(
      'button',
      primary ? 'button--primary' : '',
      secondary ? 'button--secondary' : '',
      getAnalyticsClass(analytics),
      className
    )}
    {...restProps}
  />
);

Button.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  className: PropTypes.string,
  analytics: PropTypes.oneOf([BUTTON_KEY, TEXT_KEY]),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

const ThemedButton = props => {
  const { theme, className, ...restProps } = props;
  const themeClass = useTheme(theme);
  return (
    <Button
      {...restProps}
      className={combineClassNames(themeClass, className)}
    />
  );
};

const PrimaryButton = props => <Button {...props} primary />;

const SecondaryButton = props => <Button {...props} secondary />;

export {
  Button,
  ButtonText,
  ButtonIcon,
  ThemedButton,
  PrimaryButton,
  SecondaryButton
};
